import { Container, Row } from "reactstrap";
import BarChart from "./BarChart";
import DoughnutChart from "./DoughnutChart";
import LineChart from "./LineChart";
import LineGraph from "./LineGraph";
import PolarChart from "./PolarChart";
import RadarGraph from "./RadarGraph";
import { ChartJSChart, Charts } from "../../../constants";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";

const ChartJsChartContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={ChartJSChart} parent={Charts} />
      <Container fluid>
        <Row>
          <BarChart />
          <LineGraph />
          <RadarGraph />
          <LineChart />
          <DoughnutChart />
          <PolarChart />
        </Row>
      </Container>
    </>
  );
};
export default ChartJsChartContainer;
